$(document).ready(function(){
  $('.slick-collection-slider').slick({
    slidesToShow: 6,
    arrows: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024, // Tablet breakpoint
        settings: {
          arrows: true,
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768, // Mobile breakpoint
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
});

function sortSizeFilters() {
  const filterSections = document.querySelectorAll('.collection-sidebar__group');
  
  filterSections.forEach(section => {
    const filterTitle = section.querySelector('.collapsible-trigger__layout span');
    if (filterTitle && filterTitle.textContent.trim() === 'Size') {
      const tagList = section.querySelector('.tag-list');
      if (tagList) {
        const tagItems = Array.from(tagList.querySelectorAll('.tag'));
        
        tagItems.sort((a, b) => {
          const textA = a.querySelector('.product-tag__text').textContent.trim();
          const textB = b.querySelector('.product-tag__text').textContent.trim();
          
          const getNum = (text) => parseFloat(text.match(/^(\d+(?:\.\d+)?)/)?.[1] || 0);
          return getNum(textA) - getNum(textB);
        });
        
        tagList.innerHTML = '';
        tagItems.forEach(item => tagList.appendChild(item));
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', sortSizeFilters);


// Select all swatch radio inputs for the option, e.g. 'Size'
// const swatchRadios = document.querySelectorAll('input[type="radio"][name="Size"]');

// swatchRadios.forEach(radio => {
//   radio.addEventListener('change', (event) => {
//     if (event.target.checked) {
//       console.log('Swatch selected:', event.target.value); // e.g. "3x5"
//       // Do something on variant change here
//     }
//   });
// });

function copyCode(el) {
  const originalText = el.innerText; 
  const code = originalText.replace("Use Code: ", "").trim();

  navigator.clipboard.writeText(code).then(() => {
    // Change button text
    el.innerText = "Code Copied!";

    // Reset after 5 seconds
    setTimeout(() => {
      el.innerText = originalText;
    }, 5000);
  });
}